if (!customElements.get('ark-product-gallery')) {
  customElements.define(
    'ark-product-gallery',
    class ArkProductGallery extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.ark-pdp-gallery__slide'));
        this.thumbButtons = Array.from(this.querySelectorAll('.ark-pdp-gallery__thumb'));
        this.prevBtn = this.querySelector('.ark-pdp-gallery__nav--prev');
        this.nextBtn = this.querySelector('.ark-pdp-gallery__nav--next');
        this.liveRegion = this.querySelector('[id^="ArkGalleryStatus"]');
        this.thumbsList = this.querySelector('.ark-pdp-gallery__thumbs');

        if (this.slides.length <= 1) return;

        this.thumbButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const index = Number.parseInt(button.dataset.index, 10);
            if (!Number.isNaN(index)) this.setActiveIndex(index);
          });
        });

        this.prevBtn?.addEventListener('click', () => this.setActiveIndex(this.currentIndex - 1));
        this.nextBtn?.addEventListener('click', () => this.setActiveIndex(this.currentIndex + 1));

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setActiveIndex(this.currentIndex - 1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.setActiveIndex(this.currentIndex + 1);
          }
        });

        this.updateNavState();
      }

      setActiveIndex(index) {
        if (index < 0 || index >= this.slides.length || index === this.currentIndex) return;

        const previousSlide = this.slides[this.currentIndex];
        const nextSlide = this.slides[index];
        const previousThumb = this.thumbButtons[this.currentIndex];
        const nextThumb = this.thumbButtons[index];

        previousSlide?.classList.remove('is-active');
        previousSlide?.setAttribute('hidden', '');
        nextSlide?.classList.add('is-active');
        nextSlide?.removeAttribute('hidden');

        previousThumb?.classList.remove('is-active');
        previousThumb?.removeAttribute('aria-current');
        nextThumb?.classList.add('is-active');
        nextThumb?.setAttribute('aria-current', 'true');

        this.currentIndex = index;
        this.scrollThumbIntoView(nextThumb);
        this.updateNavState();
        this.announceSlide(index);
      }

      scrollThumbIntoView(thumbButton) {
        if (!thumbButton || !this.thumbsList) return;
        const thumbItem = thumbButton.closest('.ark-pdp-gallery__thumb-item');
        if (!thumbItem) return;

        thumbItem.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });
      }

      updateNavState() {
        if (!this.prevBtn || !this.nextBtn) return;
        this.prevBtn.disabled = this.currentIndex <= 0;
        this.nextBtn.disabled = this.currentIndex >= this.slides.length - 1;
      }

      announceSlide(index) {
        if (!this.liveRegion) return;
        const slide = this.slides[index];
        const img = slide?.querySelector('img');
        if (!img) return;

        const position = index + 1;
        const template = window.accessibilityStrings?.imageAvailable;
        this.liveRegion.setAttribute('aria-hidden', 'false');
        this.liveRegion.textContent = template
          ? template.replace('[index]', position)
          : `Image ${position} of ${this.slides.length}`;
        window.setTimeout(() => {
          this.liveRegion.setAttribute('aria-hidden', 'true');
        }, 2000);
      }
    }
  );
}
